module.exports = __webpack_public_path__ + "img/path_12.acb2eeee.jpg";